module.exports = __webpack_public_path__ + "img/logoLongNavy.2f39f9e7.png";